// extracted by mini-css-extract-plugin
module.exports = {"carousel":"C_Q","large":"C_R"};